<script lang="ts">
  import Card from '$shared/atoms/Card/Card.svelte';
  import InfoAlert from '$shared/atoms/InfoAlert/InfoAlert.svelte';
  import Loader from '$shared/atoms/Loader/Loader.svelte';
  import UIErrorMessage from '$shared/constants/UIErrorMessage';
  import PageView from '$shared/organisms/PageView/PageView.svelte';
  import type { ReviewTemplateBannerInfo } from '$shared/components/types';

  interface Props {
    name?: string;
    loading?: boolean;
    nonReviewable?: boolean;
    infoAlertLabel?: string;
    bannerInfo?: ReviewTemplateBannerInfo;
    children?: import('svelte').Snippet;
    onclickInfoAlert?: () => void;
  }

  let {
    name = '',
    loading = false,
    nonReviewable = false,
    infoAlertLabel = '',
    bannerInfo = {},
    children,
    onclickInfoAlert
  }: Props = $props();

  const onClickInfo = (): void => {
    onclickInfoAlert?.();
  };
</script>

<div class="content">
  {#if nonReviewable}
    <div class="info-alert">
      <InfoAlert
        infoAlertLabel={infoAlertLabel || UIErrorMessage.UnknowError}
        onclick={onClickInfo}
      />
    </div>
  {:else}
    <PageView {name}>
      {#if loading}
        <div class="loader"><Card><Loader count={3} /></Card></div>
      {:else}
        {#if bannerInfo?.label}
          <div class="banner">
            <div data-cy="banner-text" class="text">
              {@html bannerInfo.label}
              {#if bannerInfo.subLabel}
                <div data-cy="banner-sub-text" class="sub-text">
                  {@html bannerInfo.subLabel}
                </div>
              {/if}
            </div>
            <div data-cy="banner-date" class="date">{bannerInfo.date || ''}</div>
          </div>
        {/if}
        {@render children?.()}
      {/if}
    </PageView>
  {/if}
</div>

<style>
  .content {
    grid-column: 1 / span 12;
    padding-bottom: 22px;
  }
  .banner {
    background-color: #ffffff;
    border: 1px solid #0d54f5;
    box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 16px;
    margin-bottom: 32px;
  }
  .banner .text {
    font-weight: 500;
    font-size: 16px;
    line-height: 23px;
    color: var(--blue);
  }
  .banner .text .sub-text {
    font-size: 11px;
    margin-top: 8px;
  }
  .banner .date {
    font-weight: normal;
    font-size: 12px;
    line-height: 23px;
    color: var(--grey-medium);
    margin-left: 16px;
  }
</style>
